import React from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";

import { useNavigate } from "react-router-dom";
import {
  Button,
  CustomInput,
  Description,
  SubTitle,
  UnorderedList,
} from "../../Components/CustomComponents";
import { removeToken } from "../../Data/services/localStorageService";
import Toast from "../../Hooks/useToast";
import { WEB_ROUTES } from "../../constants";
import styles from "./styles/ChangePassword.module.scss";
import { useChangePasswordMutation } from "../../Data/services/profileApi";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";

export default function ChangePassword() {
  const { handleSubmit, control, register } = useForm();
  const navigate = useNavigate();
  const [changePassword, { isSuccess, isLoading, isError }] =
    useChangePasswordMutation();

  const handleDataSubmission = async (userData) => {
    try {
      const response = await changePassword(userData).unwrap();
      removeToken();
      Toast(response?.message, "success");
      navigate(WEB_ROUTES.ACCOUNT);
    } catch (error) {
      Toast(error?.data?.message, "error");
    }
  };
  return (
    <div className={styles.ChangePassword}>
      <SubTitle text="Change Password" classes="text-white" />
      <Description text="" classes="fs-8 mb-4" />
      <Form onSubmit={handleSubmit(handleDataSubmission)}>
        <div className={styles.form}>
          <Description text="Current Password" classes="mb-1" />
          <Controller
            control={control}
            name="current_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomInput
                placeholder="Current Password"
                type="password"
                onChange={onChange}
              />
            )}
          />
          <Description text="Set New Password" classes="mt-3 mb-1" />
          <Controller
            control={control}
            name="new_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomInput
                placeholder="New Password"
                type="password"
                onChange={onChange}
              />
            )}
          />
          <Controller
            control={control}
            name="confirm_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <CustomInput
                placeholder="Confirm Password"
                type="password"
                onChange={onChange}
              />
            )}
          />
          <UnorderedList
            lists={[
              "At least 12 characters long but 14 or more is better.",
              "A combination of uppercase letters, lowercase letters, numbers, and symbols.",
            ]}
            classes="fs-6 mt-4 mb-4"
          />

          <div className={styles.saveButton}>
            <Button
              text={isLoading ? <LoadingButton /> : "Change Password"}
              classes="fs-6 mb-2 mt-auto"
              type="submit"
              disabled={isLoading}
            />
          </div>
        </div>
      </Form>
    </div>
  );
}
